"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mode = void 0;
/**
 * Result type
 */
var Mode;
(function (Mode) {
    Mode["None"] = "None";
    Mode["Always"] = "Always";
})(Mode = exports.Mode || (exports.Mode = {}));

//# sourceMappingURL=InterimResults.js.map
